fragment torahMelodyDetails on TorahMelodyType {
  id
  description
}
